import React from 'react';
import { modules } from '../data/modules';
export function Modules() {
  return <section className="border-b border-line bg-carbon py-8 sm:py-10" data-id="element-107" data-mp="1r63rh4h50cko">
      <div className="mx-auto max-w-[1080px] px-4 sm:px-6" data-id="element-108" data-mp="1r493tiehe6cw">
        <h2 className="text-center text-[26px] font-bold leading-none text-white sm:text-[40px]" data-id="element-109" data-mp="1vy3nilu36lbz">
          What's <span className="text-brandorange" data-id="element-110" data-mp="20uu2t6y2hcwc">included</span>
        </h2>

        <div className="mt-5 grid gap-3 lg:grid-cols-2" data-id="element-111" data-mp="146ee1d2s77ka">
          {modules.map(module => <article key={module.label} className="flex flex-col border border-line bg-panel2 p-4" style={{
          borderLeft: `4px solid ${module.color}`
        }} data-id="element-112" data-mp="186y827s25v27">
              <p className="font-display text-[12px] uppercase tracking-[0.16em]" style={{
            color: module.color
          }} data-id="element-113" data-mp="1i5xhhsknduq9">
                {module.label}
              </p>
              <h3 className="mt-1 text-[17px] font-bold leading-[1.08] text-white sm:text-[21px]" data-id="element-114" data-mp="2tjrlhb66xbpm">
                {module.title}
              </h3>
              <p className="mt-2 text-[13.5px] font-medium leading-snug text-metal sm:text-[15px]" data-id="element-115" data-mp="1sqhpdzbpxtt">
                {module.body}
              </p>
              <p className="mt-auto pt-3 font-display text-[13px] uppercase tracking-wide text-white" data-id="element-116" data-mp="3oypw5rseuo71">
                {module.tagline}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}